/**
 * @param {Array} filters - An array of objects containing key value pairs of filter params. Key should match the filter name outlined in fulfillment-offerings API documentation
 * @returns {String} - Returns an string of formatted filter params that omit any falsey values
 */

var filterAndFormatParams = function filterAndFormatParams(filters) {
  return filters.reduce(function (accu, current) {
    var key = Object.keys(current)[0];
    var value = current[key];
    if (!value) return accu;
    return accu.concat("filter=".concat(key, "(").concat(value, ")&"));
  }, '');
};
export default filterAndFormatParams;